import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'

import { GlobalStyle, Routes } from './config'
import AppLoader from './components/atoms/app-loader'
import AuthProvider from './contexts/auth'
import store from './store'

export default function App(): JSX.Element {
  return (
    <>
      <GlobalStyle />
      <AuthProvider
        clearStorage={() => window.localStorage.clear()}
        getItemStorage={key => window.localStorage.getItem(key)}
        loader={<AppLoader />}
        setItemStorage={(key, value) => window.localStorage.setItem(key, value)}
      >
        <Provider store={store.store}>
          <PersistGate loading={null} persistor={store.persistor}>
            <Routes />
          </PersistGate>
        </Provider>
      </AuthProvider>
    </>
  )
}
